import { LtiConsumedToolSchema } from '@efdigital/ll-admin-v2/data/schemas/lti/consumed-tool';
import { LtiConsumedToolDeploymentSchema } from '@efdigital/ll-admin-v2/data/schemas/lti/consumed-tool-deployment';
import { LtiConsumingPlatformSchema } from '@efdigital/ll-admin-v2/data/schemas/lti/consuming-platform';
import { LtiResourceLinkSchema } from '@efdigital/ll-admin-v2/data/schemas/lti/resource-link';

export const LtiSchemas = {
  LtiConsumingPlatformSchema,
  LtiConsumedToolSchema,
  LtiConsumedToolDeploymentSchema,
  LtiResourceLinkSchema,
};

export const LtiFragments = {};
